const FILE_SAFE_NAME_REGEX = /[^a-zA-Z0-9._-]/g;

export const sanitizeS3FileName = (name: string): string => {
  const trimmed = (name || 'file').trim();
  const replaced = trimmed.replace(FILE_SAFE_NAME_REGEX, '_');
  return replaced.slice(0, 120) || 'file';
};
